import FormMaster from '../FormMaster'
const ProductGroup = () => {
  return <FormMaster
    title="ข้อมูลกลุ่มสินค้า"
    tableConfig={{
      key: "id",
      apiPath: "prodgroup/list",
      allowDelete: {
        visible: true,
        key: "group_id",
        apiPath: "prodgroup/delete"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: "ลำดับ",
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'group_name',
          caption: "ชื่อกลุ่มสินค้า",
          allowFiltering: true
        },
        {
          dataField: 'description',
          caption: "คำอธิบาย"
        },
        {
          dataField: 'updated_by',
          caption: "แก้ไขโดย"
        }
      ],
      exportExcel: {
        fileName: 'ข้อมูลกลุ่มสินค้า',
        columnConfig: [
          { label: 'ลำดับ', value: 'no' },
          { label: 'ชื่อกลุ่มสินค้า', value: 'group_name' },
          { label: 'คำอธิบาย', value: 'description' },
          { label: 'แก้ไขโดย', value: 'updated_by' }
        ]
      }
    }}
    formData={{
      group_name: "",
      description: ""
    }}
    modalConfig={{
      visible: true,
      title: "กลุ่มสินค้า",
      required: ["group_name"],
      fieldTypeNumber: [],
      paramName: "group_id",
      apiPath: {
        "get": '',
        "post": 'prodgroup/add',
        "put": 'prodgroup/update'
      },
      elements: [
        {
          fieldName: "group_name",
          label: "ชื่อกลุ่มสินค้า",
          placeholder: "ชื่อกลุ่มสินค้า",
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "description",
          label: "คำอธิบาย",
          placeholder: "คำอธิบาย",
          inputType: "text",
          isOneRow: true
        }
      ]
    }}
  />
}

export default ProductGroup